import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { styled } from '../../system';
import { forwardRef } from 'react';
export const ProgressBar = forwardRef(({ value, labelPosition = 'right', showLabel = false, max = 100, ...props }, ref) => (_jsxs(StyledProgressRoot, { ref: ref, ...props, labelPosition: labelPosition, max: max, children: [_jsx(StyledProgressTrack, { labelPosition: labelPosition, children: _jsx(StyledProgressIndicator, { css: { w: `${value}%` } }) }), showLabel && (_jsxs(StyledProgressLabel, { css: { left: `${value}%` }, labelPosition: labelPosition, children: [value, "%"] }))] })));
const StyledProgressRoot = styled(ProgressPrimitive.Root, {
    d: 'inline-flex',
    minMaxH: '$2',
    position: 'relative',
    color: '$primary',
    w: '$full',
    variants: {
        labelPosition: {
            right: {},
            bottomRight: {
                flexDir: 'column',
                alignItems: 'flex-end',
                gap: '$2'
            },
            floating: {},
            floatingBottom: {}
        }
    }
});
const StyledProgressTrack = styled('span', {
    d: 'inline-flex',
    flex: 1,
    position: 'relative',
    bgColor: '$progressBarBg',
    minMaxH: '$2',
    rounded: '$full',
    overflow: 'hidden',
    variants: {
        labelPosition: {
            right: {},
            bottomRight: {
                minMaxW: '$full'
            },
            floating: {},
            floatingBottom: {}
        }
    }
});
const StyledProgressIndicator = styled(ProgressPrimitive.Indicator, {
    d: 'inline-flex',
    bgColor: '$progressBarIndicator',
    minMaxH: '$2',
    rounded: '$full',
    position: 'absolute',
    left: 0,
    top: 0,
    '@media (prefers-reduced-motion: no-preference)': {
        willChange: 'width',
        transition: 'width 0.3s ease-in-out'
    }
});
const floatingLabelStyle = {
    minMaxH: 34,
    position: 'absolute',
    rounded: '$lg',
    px: '$3',
    bgColor: '$surface',
    border: '1px solid $separatorColor',
    shadow: '$lg',
    textXs: true,
    transform: 'translateX(-50%)'
};
const StyledProgressLabel = styled('span', {
    color: '$text',
    flexCenter: true,
    fontWeight: '$medium',
    variants: {
        labelPosition: {
            right: { ml: '$3', left: 'auto !important', textSm: true },
            bottomRight: { left: 'auto !important', textSm: true },
            floating: {
                ...floatingLabelStyle,
                bottom: '$4'
            },
            floatingBottom: {
                ...floatingLabelStyle,
                top: '$4'
            }
        }
    }
});
ProgressBar.displayName = 'ProgressBar';
